import { getAddressComponent } from '@/common/helpers/helpers';

export const getAutocompleteSuggestions = (query, suggestionsCenter) => {
    const service = new window.google.maps.places.AutocompleteService();
    let bounds = new window.google.maps.LatLngBounds(
        { lat: 26.182159, lng: -126.715985 },
        { lat: 49.156529, lng: -58.817731 }
    );

    let predictionProps = { bounds };

    if (suggestionsCenter) {
        const radius = 15000;
        const circle = new google.maps.Circle({
            center: suggestionsCenter,
            radius: radius,
        });

        predictionProps = { locationBias: circle };
    }

    return service.getPlacePredictions({ input: query, ...predictionProps }).then((data) =>
        data.predictions.map((item) => ({
            place_id: item.place_id,
            description: item.description,
        }))
    );
};

export const getPlaceDetails = ({ place_id, description }, additionalPlacesData = []) => {
    const service = new google.maps.places.PlacesService(document.createElement('div'));

    return new Promise((resolve, reject) => {
        service.getDetails(
            {
                placeId: place_id,
                fields: ['address_components', 'place_id', 'geometry.location', ...additionalPlacesData],
            },
            (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    const additionallyFetchedPlaceData = Object.fromEntries(
                        additionalPlacesData.filter((key) => key in place).map((key) => [key, place[key]])
                    );

                    const { place_id, address_components, geometry } = place;

                    const addressComponents = getAddressComponent(address_components);

                    resolve({
                        place_id: place_id,
                        airbnb_address: description,
                        address_1: `${addressComponents.street_number} ${addressComponents.street}`.trim(),
                        address_2: '',
                        city: addressComponents.city,
                        state: addressComponents.state,
                        zip: addressComponents.postalCode,
                        lat: geometry?.location?.lat(),
                        lng: geometry?.location?.lng(),
                        country_short: addressComponents?.country_short,
                        ...additionallyFetchedPlaceData,
                    });
                } else {
                    reject(new Error(`Failed to fetch place details. Status: ${status}`));
                }
            }
        );
    });
};

export const getNearbyPlaces = async (
    lat,
    lng,
    config = {
        types: [],
        radius: 5000,
        max: 6,
    },
    photoConfig = {
        maxWidth: 0,
    }
) => {
    const { Place, SearchNearbyRankPreference } = await google.maps.importLibrary('places');

    const location = new window.google.maps.LatLng(lat, lng);

    const { places } = await Place.searchNearby({
        fields: ['displayName', 'location', 'businessStatus', 'photos', 'formattedAddress', 'types'],
        locationRestriction: {
            center: location,
            radius: config.radius,
        },
        includedPrimaryTypes: config.types,
        maxResultCount: config.max,
        rankPreference: SearchNearbyRankPreference.POPULARITY,
        language: 'en-US',
        region: 'us',
    });

    return places.map((place) => {
        let image = '';

        if (place?.photos?.length) {
            const photo = place.photos[0];
            const maxWidth = photoConfig?.maxWidth ? photoConfig.maxWidth : photo.widthPx;
            image = photo.getURI({ maxWidth });
        }

        return {
            id: place.id,
            place_id: place.id,
            name: place.displayName,
            image,
            description: place?.formattedAddress,
            types: place?.types,
        };
    });
};
